<template>
  <div v-if="backgroundImage" class="marquee" :style="{ backgroundImage: 'url(' + backgroundImage + ')' }">
    <el-row>
      <el-col :xs="{ span: 22, offset: 1 }" :sm="{ span: 18, offset: 3 }" :md="{ span: 12, offset: 6 }"
        :lg="{ span: 12, offset: 6 }" class="product-intro">
        <h1 class="light">{{ headline }}</h1>
        <p class="light">{{ subhead }}</p>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import products from './';
import user from '../user';

export default {
  name: 'ProductInfoMarquee',
  computed: {
    ...mapState(products.store.namespace, [
      'productsOverview'
    ]),
    ...mapGetters(user.store.namespace, [
      'isTrainingEnabled'
    ]),
    headline() {
      return this.productsOverview.productsOverviewMarqueeHeadline;
    },
    subhead() {
      return this.productsOverview.productsOverviewMarqueeSubhead;
    },
    backgroundImage() {
      return (this.productsOverview.productsOverviewMarqueeImage &&
        this.productsOverview.productsOverviewMarqueeImage.length) ?
        this.productsOverview.productsOverviewMarqueeImage[0].url
        : false;
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'element-theme-chalk/src/mixins/mixins.scss';

.marquee {
  width: 100%;
  margin-bottom: -12rem;
  padding: 8rem 0 20rem 0;

  @include res(xs) {
    padding: 2rem 0;
    margin-bottom: 25px;
  }

  @include res(sm) {
    padding: 4rem 0 16rem 0;
  }

  background-size: cover;
  background-repeat: no-repeat;
  background-color: #04090c;
}

.product-intro {
  text-align: center;
}

h1 {
  @include res(sm-and-down, $--breakpoints-spec) {
    font-size: 2.25rem;
  }

  @include res(md-only, $--breakpoints-spec) {
    font-size: 2.5rem;
  }
}
</style>
